import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-privacy-harvester-dialog',
    templateUrl: './privacy-harvester-dialog.component.html',
    styleUrls: ['./privacy-harvester-dialog.component.css'],
    standalone: false
})
export class PrivacyHarvesterDialogComponent {

  declarationChecked: boolean = false;

  constructor(public dialogRef: MatDialogRef<PrivacyHarvesterDialogComponent>) { }

}
